import React from 'react'
import { useContext} from 'react'
import { CartContext } from '../contexts/CartContext'
import { EmptyCart } from './EmptyCart'
import { FilledCart } from './FilledCart'

export const Cart = () => {
    const { cart } = useContext(CartContext)
    return (
        <div>


            {
                cart.length === 0 ? <EmptyCart /> : <FilledCart />
            }


        </div>
    )

}
